module.exports = __webpack_public_path__ + "img/center_left.f58dfecc.svg";